import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/settings/app-constants';
import { URI } from 'src/app/settings/uri-constants';

@Component({
    selector: 'app-select-user-type',
    templateUrl: './select-type.component.html',
    styleUrls: ['./select-type.component.css'],
})
export class SelectTypeComponent {
    @Input() type: string;
    userTypes = AppConstants.ALLOWED_USER_TYPES;

    constructor(private router: Router) { }

    changeType(displayName: string) {
        console.log('Selected type:', displayName);

        // Find the key from displayName
        const userTypeKey = Object.keys(this.userTypes).find(
            key => this.userTypes[key] === displayName
        );

        // If no matching key is found
        if (!userTypeKey) {
            console.warn('Invalid user type selected.');
            return;
        }

        // Navigate based on the key
        switch (userTypeKey) {
            case 'staff':
                this.router.navigate([URI.SLASHED_ADD_STAFF]);
                break;

            case 'wholesaler':
            case 'supplier':
                this.router.navigate([URI.SLASHED_ADD_ENTERPRISE], {
                    queryParams: { enterpriseType: userTypeKey }
                });
                break;

            default:
                console.warn('Unhandled user type key:', userTypeKey);
        }
    }
}
